module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/150503fb4db3881f43e910d8ad01a660.png";